/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var _t = function t() {
  return (_t = Object.assign || function (t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) for (var o in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
    return t;
  }).apply(this, arguments);
};
function e(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;
    for (r = Object.getOwnPropertySymbols(t); o < r.length; o++) e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
  }
  return n;
}
function n(t, e, n, r) {
  return new (n || (n = Promise))(function (o, a) {
    function l(t) {
      try {
        u(r.next(t));
      } catch (t) {
        a(t);
      }
    }
    function c(t) {
      try {
        u(r.throw(t));
      } catch (t) {
        a(t);
      }
    }
    function u(t) {
      var e;
      t.done ? o(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
        t(e);
      })).then(l, c);
    }
    u((r = r.apply(t, e || [])).next());
  });
}
function r(t, e) {
  var n,
    r,
    o,
    a,
    l = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
  return a = {
    next: c(0),
    throw: c(1),
    return: c(2)
  }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
    return this;
  }), a;
  function c(a) {
    return function (c) {
      return function (a) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; l;) try {
          if (n = 1, r && (o = 2 & a[0] ? r.return : a[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, a[1])).done) return o;
          switch (r = 0, o && (a = [2 & a[0], o.value]), a[0]) {
            case 0:
            case 1:
              o = a;
              break;
            case 4:
              return l.label++, {
                value: a[1],
                done: !1
              };
            case 5:
              l.label++, r = a[1], a = [0];
              continue;
            case 7:
              a = l.ops.pop(), l.trys.pop();
              continue;
            default:
              if (!(o = l.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                l = 0;
                continue;
              }
              if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                l.label = a[1];
                break;
              }
              if (6 === a[0] && l.label < o[1]) {
                l.label = o[1], o = a;
                break;
              }
              if (o && l.label < o[2]) {
                l.label = o[2], l.ops.push(a);
                break;
              }
              o[2] && l.ops.pop(), l.trys.pop();
              continue;
          }
          a = e.call(t, l);
        } catch (t) {
          a = [6, t], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & a[0]) throw a[1];
        return {
          value: a[0] ? a[1] : void 0,
          done: !0
        };
      }([a, c]);
    };
  }
}
export { _t as __assign, n as __awaiter, r as __generator, e as __rest };